import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { authGuard, authGuardChild } from './shared/guards/auth.guard';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuardChild],
    loadChildren: () =>
      import('./layout/default-layout/default-layout.module').then(
        m => m.DefaultLayoutModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./layout/auth-layout/auth-layout.module').then(
        m => m.AuthLayoutModule
      ),
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
